import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const deleteSavedView: YJSChangeHandler<DatabaseChangeType.DELETE_SAVED_VIEW> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    db.deleteView(change.viewId);
  });
};
